import { FOCUS_VISIBLE_RING } from '../../../lib/a11yFocus'

type CompanyInviteCardProps = {
	activeResult?: object
	result: {
		name: String
		company_number: String
		address: String
	}
	isInteractable: Boolean
	setActiveResult?: Function
	clickHandler?: Function
	additionalClasses?: string
}

function CompanyInviteCard(props: CompanyInviteCardProps) {
	const baseClasses = `p-xl ${
		props.activeResult === props.result
			? 'bg-algae-100 ring ring-algae-500 '
			: 'bg-white  mt-md'
	} ${props.additionalClasses && props.additionalClasses} `

	if (!props.isInteractable) {
		return (
			<div className={baseClasses}>
				<p className='text-charcoal-900 leading-5 text-sm'>{props.result.name}</p>
				<p className='text-charcoal-900 leading-5 text-sm mb-3'>
					{props.result.company_number}
				</p>
				<p className='text-charcoal-400 leading-5 text-sm'>{props.result.address}</p>
			</div>
		)
	}

	return (
		<button
			type='button'
			className={`${baseClasses} w-full text-left cursor-pointer ${FOCUS_VISIBLE_RING}`}
			onClick={() => {
				if (props.clickHandler) props.clickHandler()
			}}
		>
			<p className='text-charcoal-900 leading-5 text-sm'>{props.result.name}</p>
			<p className='text-charcoal-900 leading-5 text-sm mb-3'>
				{props.result.company_number}
			</p>
			<p className='text-charcoal-400 leading-5 text-sm'>{props.result.address}</p>
		</button>
	)
}

export default CompanyInviteCard
